"use client"

import { PenOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PenOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PenOffIcon = component(Icon)({ as: PenOff })
